import React, { useState, useEffect } from 'react';
import { Snackbar, Slide, SnackbarContent } from '@material-ui/core';


const AlertComponent = (props) => {
    useEffect(() => {
        if (props.open) setTransition(() => transitionRight)
    }, [props.open]);
    const [transition, setTransition] = useState(undefined);

    const transitionRight = (props) => {
        return <Slide {...props} direction="down" />;
    }
    return (
        <Snackbar
            open={props.open}
            autoHideDuration={3000}
            onClose={props.handleClose}
            TransitionComponent={transition}
            key={transition ? transition.name : ''}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            style={{ top: '110px' }}
        >
            <SnackbarContent style={{
                backgroundColor: props.color
            }}
                message={<span id="client-snackbar">{props.msg}</span>}
            />
        </Snackbar>
    );
};

export default AlertComponent;

